import AntSteps from 'antd/lib/steps';

const {Step} = AntSteps;

Step.defaultProps = {
	status: 'default',
};

export {Step};
